import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ApplicationService } from 'src/app/services/app.service';
import { BaseDirective } from '../../base.directive';
import { OverlayMenuSettings, ApplicationLink } from '../../utilities/settings.interfaces';

import * as dayjs from 'dayjs';

@Component({
    selector: 'a-overlay-menu',
    templateUrl: './overlay-menu.component.html',
    styleUrls: ['./overlay-menu.component.scss']
})
export class OverlayMenuComponent extends BaseDirective {
    /** Whether to show the menu */
    @Input() public show: boolean;
    /** Emitter for changes to show */
    @Output() public showChange = new EventEmitter<boolean>();

    /** List of links to display on the menu */
    public get menu_items(): ApplicationLink[] {
        return this.settings ? this.settings.items : [];
    }

    /** Copyright details for the application */
    public get copyright(): string {
        return this.settings ? this.settings.copyright : '';
    }

    public get settings() {
        const settings = this._service.setting('app.general.menu') || { position: '' };
        return settings;
    }

    constructor(private _service: ApplicationService) {
        super();
    }

    /** Current year to display for copyright */
    public get year(): number {
        return dayjs().year();
    }

    /** Close the overlay menu */
    public close() {
        this.show = false;
        this.showChange.emit(this.show);
    }

    public delayedClose() {
        this.timeout('close', () => this.close(), 50);
    }

    public cancelClose() {
        this.timeout('cancel_close', () => this.clearTimeout('close'), 10);
    }
}
